import { useQuery } from '@tanstack/react-query';
import { api } from './api';

/**
 * What this deployment offers (D-369), from `GET /api/admin/settings/features`.
 *
 * QuickBooks and the previous system's history and migration tools are hidden
 * behind switches in Admin → Settings; loyalty and gift cards were BRE
 * services and are off unless the API is configured for them; account credit
 * arrives with Phase C2. Everything **fails closed**: until the answer is in,
 * or if it cannot be read, a feature is treated as absent.
 */
export interface AdminFeatures {
  loyalty: boolean;
  gift_cards: boolean;
  account_credit: boolean;
  quickbooks: boolean;
  history_import: boolean;
}

export type AdminFeature = keyof AdminFeatures;

export const NO_FEATURES: AdminFeatures = { loyalty: false, gift_cards: false, account_credit: false, quickbooks: false, history_import: false };

export const featureEndpoints = {
  features: () => api.get<AdminFeatures>('/api/admin/settings/features'),
};

export function useFeatures(): AdminFeatures {
  const features = useQuery({ queryKey: ['admin-features'], queryFn: featureEndpoints.features, staleTime: 30_000 });
  return { ...NO_FEATURES, ...(features.data ?? {}) };
}
